export default __webpack_public_path__ + "static/media/overpower.bdfaebb8.png";